import React from 'react';

interface ErrorMessageProps {
  message: string;
  onDismiss?: () => void;
  type?: 'error' | 'warning' | 'info';
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  onDismiss, 
  type = 'error' 
}) => {
  return (
    <div className={`error-message ${type}`}>
      <span className="error-text">{message}</span>
      {onDismiss && (
        <button 
          className="error-dismiss"
          onClick={onDismiss}
          aria-label="エラーメッセージを閉じる"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;